import * as PIXI from 'pixi.js';
import { LayoutContainer } from '@pixi/layout/components'; // eslint-disable-line
import AssetsLoader from '../utils/assetsLoader';
import { APP_WIDTH, APP_HEIGHT, redrawFullScreenOverlay } from '../utils/commonUtils';

import ButtonContainer from './buttonContainer';

export default class WinLoseContainer extends PIXI.Container {
    constructor(gameState) {
        super();

        const isFindMatchMode = gameState.clientGameState.isFindMatchMode;

        const darkOverlayGraphics = new PIXI.Graphics();
        darkOverlayGraphics.label = 'darkOverlayGraphics';
        darkOverlayGraphics.x = 0;
        darkOverlayGraphics.y = 0;
        darkOverlayGraphics.rect(-APP_WIDTH / 2, -APP_HEIGHT / 2, APP_WIDTH, APP_HEIGHT);
        darkOverlayGraphics.fill({ color: '#000000' });
        darkOverlayGraphics.alpha = 0.7;
        this.addChild(darkOverlayGraphics);

        const victorySprite = new PIXI.Sprite();
        victorySprite.label = 'victorySprite';
        victorySprite.texture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.VICTORY);
        victorySprite.x = 0;
        victorySprite.y = -190;
        victorySprite.anchor.set(0.5);
        victorySprite.scale.set(0.7);
        victorySprite.visible = false;
        this.addChild(victorySprite);

        const defeatSprite = new PIXI.Sprite();
        defeatSprite.label = 'defeatSprite';
        defeatSprite.texture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.DEFEAT);
        defeatSprite.x = 0;
        defeatSprite.y = -190;
        defeatSprite.anchor.set(0.5);
        defeatSprite.scale.set(0.7);
        defeatSprite.visible = false;
        this.addChild(defeatSprite);

        const rewardContainer = new LayoutContainer({
            layout: {
                width: APP_WIDTH,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 16,
            },
        });
        rewardContainer.label = 'rewardContainer';
        rewardContainer.x = -APP_WIDTH / 2;
        rewardContainer.y = 220;
        rewardContainer.visible = false;
        this.addChild(rewardContainer);

        const rewardText = new PIXI.Text({
            text: '',
            style: {
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fontSize: 60,
                lineHeight: 72,
                fill: '#ddc341',
                align: 'center',
            },
            layout: {
                objectFit: 'none',
                objectPosition: 'center',
            },
        });
        rewardText.label = 'rewardText';
        rewardContainer.addChild(rewardText);

        const rewardCoinIcon = new PIXI.Sprite(PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.COIN));
        rewardCoinIcon.label = 'rewardCoinIcon';
        rewardCoinIcon.layout = { width: 70, height: 70 };
        rewardContainer.addChild(rewardCoinIcon);

        if (!isFindMatchMode) {
            const rematchButton = new ButtonContainer({ bgAssetName: AssetsLoader.eDefaultAssetsAliases.REMATCH_BUTTON, eventName: 'rematchButtonClicked' });
            rematchButton.label = 'rematchButton';
            rematchButton.visible = true;
            rematchButton.x = 0;
            rematchButton.y = 375;
            this.addChild(rematchButton);
        }

        const quitMatchButton = new ButtonContainer({ bgAssetName: AssetsLoader.eDefaultAssetsAliases.QUIT_MATCH_BUTTON, eventName: 'quitMatchButtonClicked' });
        quitMatchButton.label = 'quitMatchButton';
        quitMatchButton.visible = true;
        quitMatchButton.x = 0;
        quitMatchButton.y = 570;
        this.addChild(quitMatchButton);
    }

    showVictory() {
        this.getChildByLabel('victorySprite').visible = true;
    }

    showDefeat() {
        this.getChildByLabel('defeatSprite').visible = true;
    }

    showReward({ coins, firstWin, capped }) {
        const rewardContainer = this.getChildByLabel('rewardContainer');
        const rewardText = rewardContainer.getChildByLabel('rewardText');

        if (coins > 0) {
            rewardText.text = firstWin ? `+${coins} Coins\nFirst Win of the Day!` : `+${coins} Coins`;
        } else {
            rewardText.text = capped ? 'Daily Coin Limit Reached' : '';
        }

        rewardText.layout = {
            width: rewardText.width,
            height: rewardText.height,
            objectFit: 'none',
            objectPosition: 'center',
        };
        rewardContainer.visible = rewardText.text !== '';
    }

    resize(width, height) {
        redrawFullScreenOverlay(this.getChildByLabel('darkOverlayGraphics'), width, height);
    }
}